'use client';

import { MonoSmall } from '@terra/ui-design-system';
import {
  BaseEdge,
  EdgeLabelRenderer,
  type Edge,
  type EdgeProps,
} from '@xyflow/react';
import { compositionEdgePath } from '../utils/compositionGraphModel';
import {
  COMPOSITION_EDGE_COLD,
  COMPOSITION_EDGE_HOT,
  COMPOSITION_LABEL_COLD_BORDER,
  COMPOSITION_LABEL_COLD_COLOR,
  COMPOSITION_LABEL_HOT_BORDER,
  COMPOSITION_LABEL_HOT_COLOR,
} from '../utils/compositionGraphVisual';

export type CompositionEdgeData = {
  hot: boolean;
};

export type CompositionFlowEdge = Edge<CompositionEdgeData, 'compositionEdge'>;

export function CompositionEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  label,
  data,
}: EdgeProps<CompositionFlowEdge>) {
  const hot = Boolean(data?.hot);
  const { d, labelX, labelY } = compositionEdgePath({
    x1: sourceX,
    y1: sourceY,
    x2: targetX,
    y2: targetY,
  });
  const labelText = typeof label === 'string' ? label : '';

  return (
    <>
      <BaseEdge
        path={d}
        style={{
          stroke: hot ? COMPOSITION_EDGE_HOT : COMPOSITION_EDGE_COLD,
          strokeWidth: hot ? 2 : 1.25,
        }}
      />
      {labelText ? (
        <EdgeLabelRenderer>
          <MonoSmall
            position="absolute"
            pointerEvents="none"
            px="7px"
            py="4px"
            borderRadius="full"
            bg="bg.default"
            borderWidth="1px"
            lineHeight="1"
            whiteSpace="nowrap"
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              borderColor: hot
                ? COMPOSITION_LABEL_HOT_BORDER
                : COMPOSITION_LABEL_COLD_BORDER,
              color: hot
                ? COMPOSITION_LABEL_HOT_COLOR
                : COMPOSITION_LABEL_COLD_COLOR,
            }}
          >
            {labelText}
          </MonoSmall>
        </EdgeLabelRenderer>
      ) : null}
    </>
  );
}
